<ng-container *ngIf="activeUser$ | async as activeUser">
  <div class="job-detail-wrapper flex flex-col" *ngIf="(job$ | async) as job">
    <!--BASIC INFO-->
    <section class="basic-info-container">
      <mat-card
        class="h-fit !p-8 !pb-0 !shadow-none !border-b-0 !rounded-b-none"
      >
        <div class="flex flex-row w-full mb-4 items-baseline">
          <a [routerLink]="appRoutes.jobs()" mat-icon-button class="!mr-4">
            <mat-icon>arrow_back</mat-icon>
          </a>
          <section class="w-full">
            <div class="mb-4">
              <p class="mat-title text-darkGray !mb-0">
                <span>{{ job.getMatterDisplay() }}&nbsp;&dash;&nbsp;</span>
                <span *ngIf="job.company?.name" class="text-primary-default">{{
                    job.company?.name
                  }}</span>
              </p>
              <p class="!mb-0 text-lightGray !text-sub">
                <span>Created on&nbsp;</span>
                <span>{{ job.createdAt | date: "d MMM, YYYY" }} by&nbsp;</span>
                <span class="font-['OpenSans_Medium'] text-darkGray">{{
                    job.createdBy.profile.fullName
                  }}</span>
              </p>
            </div>
          </section>
        </div>

        <div class="flex flex-row w-full gap-3 h-fit pb-4">
          <section class="overview-container grow w-full">
            <mat-card class="h-full !shadow-none">
              <mat-card-title class="mat-title !text-base"
              >Details
              </mat-card-title>

              <mat-card-content>
                <div class="flex flex-row gap-4 mb-4">
                  <section class="overview-detail w-3/5">
                    <div class="flex flex-row items-center mb-4">
                      <p
                        class="!mb-0 inline-flex text-darkGray opacity-70 !mr-2 w-[16rem] max-w-xs"
                      >
                        <mat-icon class="!text-base text-center mr-2"
                        >auto_mode
                        </mat-icon>
                        <span>Status&colon;</span>
                      </p>
                      <app-status
                        [statusMessage]="job.statusLabel"
                        [statusStyle]="job.renderStatusStyleByUser(activeUser)"
                        [ngClass]="'!text-sm capitalize'"
                      ></app-status>
                      <!--                      <button mat-icon-button class="ml-2 text-grey-800">-->
                      <!--                        <mat-icon class="!text-xbase">edit</mat-icon>-->
                      <!--                      </button>-->
                    </div>
                    <div class="flex flex-row items-center mb-4">
                      <p class="!mb-0 inline-flex text-darkGray opacity-70 !mr-2 w-[16rem] max-w-xs">
                        <mat-icon class="!text-base text-center mr-2">
                          schedule
                        </mat-icon>
                        <span>Estimated Time&colon;</span>
                      </p>
                      <p class="mat-subheading-1 !mb-0 !text-sub text-darkGray">
                        {{ getEstimatedTime(job) }}&nbsp;business day(s)
                      </p>
                      <app-edit-button
                        class="ml-2"
                        *ngIf="!activeUser.isCustomer() &&
                          job.status !== JobStatusEnum.Closed &&
                          job.status !== JobStatusEnum.Done &&
                          job.status !== JobStatusEnum.Draft
                        " (click)="onEditEstimatedDate(job)">
                      </app-edit-button>
                    </div>
                    <div class="flex flex-row items-center mb-4">
                      <p
                        class="!mb-0 inline-flex text-darkGray opacity-70 !mr-2 w-[16rem] max-w-xs"
                      >
                        <mat-icon class="!text-base text-center mr-2"
                        >date_range
                        </mat-icon>
                        <span>Deadline&colon;</span>
                      </p>
                      <p class="mat-subheading-1 !mb-0 !text-sub text-darkGray">
                        {{ getJobDeadline(job) | date: "d MMM, YYYY" }}
                      </p>
                    </div>
                    <div
                      class="flex flex-row items-center"
                      *ngIf="visiblePayment$ | async"
                    >
                      <p
                        class="!mb-0 inline-flex text-darkGray opacity-70 !mr-2 w-[16rem] max-w-xs"
                      >
                        <mat-icon class="!text-base text-center mr-2"
                        >request_quote
                        </mat-icon>
                        <span>Payment Status&colon;</span>
                      </p>
                      <app-payment-status
                        *ngIf="payment$ | async as payment"
                        [payment]="payment"
                        [activeUser]="activeUser"
                        class="text-sm"
                      ></app-payment-status>
                    </div>
                  </section>
                  <mat-divider
                    vertical
                    *ngIf="job.status !== jobStatus.Draft"
                  ></mat-divider>

                  <section
                    class="assign-container w-1/2"
                    *ngIf="job.status !== jobStatus.Draft"
                  >
                    <section class="mb-4">
                      <div class="flex flex-row justify-between items-center">
                        <p class="!mb-0 inline-flex items-center gap-2 text-darkGray opacity-70">
                          <mat-icon class="!text-base text-center"
                          >assignment_ind
                          </mat-icon>
                          Expert(s): <span class="text-primary-800 font-bold">{{ (experts$ | async).length }}</span>
                        </p>
                        <app-edit-button (click)="onOpenExpertDialog(job)"
                                         *ngIf="activeUser?.isCorporateExpert()"></app-edit-button>
                      </div>

                      <div class="pl-8 mt-2">
                        <ng-container>
                          <div *ngIf="job?.experts?.length; else noExpert">
                            <app-user-assigned-chip-list
                              [users]="job?.experts"
                            ></app-user-assigned-chip-list>
                          </div>
                          <ng-template #noExpert>
                            <div
                              class="!mb-0 text-lightGray text-sub"
                              *ngIf="canAssignExpert$ | async"
                            >
                              <span>None&nbsp;&dash;&nbsp;</span>
                              <span
                                class="hover:underline hover:text-primary-default hover:cursor-pointer"
                                (click)="onOpenExpertDialog(job)"
                              >Assign Expert</span
                              >
                            </div>
                          </ng-template>
                        </ng-container>
                      </div>
                    </section>

                    <section class="mb-4">
                      <div class="flex flex-row justify-between items-center">
                        <p class="!mb-0 inline-flex items-center gap-2 text-darkGray opacity-70">
                          <mat-icon class="!text-base text-center"
                          >group
                          </mat-icon>
                          Customer(s): <span class="text-primary-800 font-bold">{{ (customers$ | async).length }}</span>
                        </p>
                        <app-edit-button (click)="onOpenCustomerDialog(job)"
                                         *ngIf="activeUser?.isCorporateExpert()"></app-edit-button>
                      </div>

                      <div class="pl-8 mt-2">
                        <ng-container>
                          <div
                            *ngIf="job?.customers?.length; else noCustomer"
                          >
                            <app-user-assigned-chip-list
                              [users]="job?.customers"
                            ></app-user-assigned-chip-list>
                          </div>
                          <ng-template #noCustomer>
                            <div
                              class="!mb-0 text-lightGray text-sub"
                              *ngIf="canAddCustomers$ | async"
                            >
                              <span>None&nbsp;&dash;&nbsp;</span>
                              <span
                                class="hover:underline hover:text-primary-default hover:cursor-pointer"
                                (click)="onOpenCustomerDialog(job)"
                              >Add Customer</span
                              >
                            </div>
                          </ng-template>
                        </ng-container>
                      </div>
                    </section>
                  </section>
                </div>
              </mat-card-content>
            </mat-card>
          </section>

          <section class="actions-container min-w-[34rem] max-w-[38rem] h-auto">
            <mat-card class="h-full !shadow-none">
              <mat-card-content class="!flex !flex-col">
                <ng-container *ngIf="job.status !== JobStatusEnum.Completed">
                  <p class="!font-secondary !font-semibold !text-black !text-base !not-italic !leading-[normal]">Pending Action(s):
                    <span
                      [ngClass]="job?.actions?.length ? 'text-red-700' : '!text-darkGray !font-bold'"
                    >{{ job?.actions?.length }}</span>
                  </p>

                  <div class="!mb-4 w-full">
                    <div *ngIf="job?.actions?.length; else noAction">
                      <ng-container *ngFor="let action of job.actions">
                        <ng-container [ngSwitch]="action.type">
                          <ng-container *ngSwitchCase="JobActionEnum.CompleteKyc">
                            <a
                              *ngIf="job.company?.id"
                              [queryParams]="{ tab: CompanyProfileTabQueryParam[CompanyProfileTab.Kyc] }"
                              [routerLink]="'/companies/' + job.company.id"
                              mat-raised-button
                              class="text-white bg-pending-action-orange w-full"
                              [matTooltip]="action.label"
                            >
                              <mat-icon
                                svgIcon="processing_document"
                                class="custom-icon-white"
                              ></mat-icon>
                              {{ action.label }}
                            </a>
                          </ng-container>

                          <button
                            (click)="confirmProfile(job.id)"
                            *ngSwitchCase="JobActionEnum.ConfirmProfile"
                            mat-raised-button
                            class="text-white bg-pending-action-orange w-full"
                            [matTooltip]="action.label"
                          >
                            <span class="inline-flex items-center justify-center gap-2 w-full">
                              <mat-icon
                                svgIcon="check_circle_outline"
                                class="custom-icon-white"
                              ></mat-icon>
                              {{ action.label }}
                            </span>
                          </button>

                          <button
                            (click)="confirmDocumentsPrepared(job.id)"
                            *ngSwitchCase="JobActionEnum.DocumentPrepared"
                            mat-raised-button
                            class="text-white bg-pending-action-orange w-full"
                            [matTooltip]="action.label"
                          >
                            <mat-icon
                              svgIcon="check_circle_outline"
                              class="custom-icon-white"
                            ></mat-icon>
                            {{ action.label }}
                          </button>

                          <button
                            (click)="confirmMarkAsComplete(job.id)"
                            *ngSwitchCase="JobActionEnum.MarkAsComplete"
                            mat-raised-button
                            class="text-white bg-[#03A66D] w-full"
                            [matTooltip]="action.label"
                          >
                            <mat-icon
                              svgIcon="check_circle_outline"
                              class="custom-icon-white"
                            ></mat-icon>
                            {{ action.label }}
                          </button>

                          <ng-container *ngSwitchCase="JobActionEnum.ConfirmKyc">
                            <button
                              *ngIf="job.company?.id"
                              (click)="confirmKyc(job.company.id)"
                              mat-raised-button
                              class="text-white bg-pending-action-orange w-full"
                              [matTooltip]="action.label"
                            >
                              <mat-icon
                                svgIcon="check_circle_outline"
                                class="custom-icon-white"
                              ></mat-icon>
                              {{ action.label }}
                            </button>
                          </ng-container>

                          <ng-container *ngSwitchCase="JobActionEnum.MakePayment">
                            <button
                              (click)="makePayment(job)"
                              mat-raised-button
                              class="!mb-3 bg-pending-action-orange text-white w-full"
                              [disabled]="isMakePaymentDisabled$ | async"
                            >
                              <mat-icon matPrefix>request_quote</mat-icon>
                              {{ action.label }}
                            </button>
                          </ng-container>

                          <button
                            (click)="confirmBilling()"
                            *ngSwitchCase="JobActionEnum.ConfirmBilling"
                            mat-raised-button
                            class="text-white bg-pending-action-orange w-full confirm-billing-button"
                            [matTooltip]="action.label"
                            [disabled]="confirmBillingLoading"
                            [attr.aria-busy]="confirmBillingLoading"
                          >
                            <span class="inline-flex items-center justify-center gap-2 w-full">
                              <mat-progress-spinner
                                *ngIf="confirmBillingLoading"
                                mode="indeterminate"
                                diameter="18"
                                strokeWidth="3"
                                class="confirm-billing-spinner"
                              ></mat-progress-spinner>
                              <mat-icon
                                *ngIf="!confirmBillingLoading"
                                svgIcon="check_circle_outline"
                                class="custom-icon-white"
                              ></mat-icon>
                              {{ action.label }}
                            </span>
                          </button>

                          <ng-container *ngSwitchCase="JobActionEnum.ApprovePayment">
                            <button
                              *ngIf="job?.order?.payment as payment"
                              (click)="approvePayment(payment)"
                              mat-raised-button
                              class="!mb-3 bg-pending-action-orange text-white w-full"
                            >
                              <mat-icon
                                svgIcon="check_circle_outline"
                                class="custom-icon-white"
                              ></mat-icon>
                              {{ action.label }}
                            </button>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </div>

                    <ng-template #noAction>
                      <div class="w-full rounded-[4px] border px-4 py-2 border-dashed border-black">
                        <div class="font-opensans-semibold text-center !py-0 !text-lightGray !text-base !not-italic !leading-[normal]">{{ job.noPendingActionLabel }}</div>
                      </div>
                    </ng-template>
                  </div>
                </ng-container>


                <p class="!font-secondary !font-semibold !text-black !text-base !not-italic !leading-[normal]">Quick Action(s)</p>

                <a
                  *ngIf="job.company?.id"
                  [routerLink]="'/companies/' + job.company.id"
                  mat-raised-button
                  class="!mb-3"
                  color="primary"
                  matTooltip="View Company Profile"
                >
                  <mat-icon matPrefix>business</mat-icon>
                  Company Profile
                </a>

                <a
                  *ngIf="job.parentId"
                  [routerLink]="'/job/' + job.parentId"
                  mat-raised-button
                  class="!mb-3 bg-[#6a59ff] text-white"
                  matTooltip="View Parent Request"
                >
                  <mat-icon matPrefix>work</mat-icon>
                  Parent Request
                </a>

                <button
                  *ngIf="!activeUser.isCustomer() && (showMarkDone$ | async)"
                  mat-raised-button
                  class="!mb-3 bg-[#03A66D] text-white"
                  appConfirmDialog
                  [confirmMessage]="commonHelper.getMarkJobDoneMessage()"
                  matTooltip="Mark Job as Done"
                  (ok)="markJobDone(job)"
                >
                  <mat-icon matPrefix>task_alt</mat-icon>
                  Mark Job Done
                </button>

                <button
                  *ngIf="
                    job.order?.payment?.canViewProofOfPayment() &&
                    job.parentId === null
                  "
                  [disabled]="job.order?.payment?.loading"
                  (click)="openProofOfPayment(job.order?.payment)"
                  mat-raised-button
                  class="!mb-3"
                  color="primary"
                  matTooltip="View Proof of Payment"
                >
                  <mat-icon matPrefix>request_quote</mat-icon>
                  View Proof of Payment
                </button>

                <button
                  *ngIf="
                    job.order?.payment?.canViewPaymentReceipt() &&
                    job.parentId === null
                  "
                  [disabled]="job.order?.payment?.loading"
                  (click)="openPaymentReceipt(job.order?.payment)"
                  mat-raised-button
                  class="!mb-3"
                  color="primary"
                  matTooltip="View Payment Receipt"
                >
                  <mat-icon matPrefix>receipt_long</mat-icon>
                  View Payment Receipt
                </button>

                <button
                  mat-raised-button
                  class="bg-[#5e6a72cc] text-white"
                  *ngIf="canCloseJob(job)"
                  appConfirmRequestDialog
                  title="Close job request?"
                  [confirmMessage]="
                    commonHelper.getCancelJobConfirmMessage(activeUser)
                  "
                  [isArlert]="true"
                  (ok)="cancelJobConfirmed(job)"
                >
                  <mat-icon matSuffix>work_off</mat-icon>
                  <span class="ml-2">Close Request</span>
                </button>
              </mat-card-content>
            </mat-card>
          </section>
        </div>
      </mat-card>
    </section>

    <!--JOB DETAIL-->
    <section class="job-detail-container">
      <mat-tab-group
        class="border border-x custom-tab"
        (selectedTabChange)="onTabChange($event)"
        [selectedIndex]="selectedIndex$ | async"
      >
        <!--CONVERSATION-->
        <mat-tab label="Conversation">
          <ng-template matTabContent>
            <app-conversation
              [job]="job"
              [isActive]="conversationTabActive$ | async"
            ></app-conversation>
          </ng-template>
        </mat-tab>
        <!--MAIN REQUEST-->
        <mat-tab *ngIf="!job.parentId" label="Main Request">
          <ng-template matTabContent>
            <app-job-main-request
              [job]="job"
              [isActive]="mainRequestTabActive$ | async"
            ></app-job-main-request>
          </ng-template>
        </mat-tab>
        <!--SCOPE OF WORK & FEE-->
        <mat-tab
          [label]="
            (visiblePayment$ | async) ? 'Scope of Work & Fees' : 'Scope of Work'
          "
        >
          <ng-template matTabContent>
            <app-job-scope-and-fee
              [job]="job"
              [isActive]="scopeAndFeeTabActive$ | async"
            ></app-job-scope-and-fee>
          </ng-template>
        </mat-tab>
        <!--JOB FILES-->
        <mat-tab label="Job Files">
          <ng-template matTabContent>
            <app-job-files
              [jobId]="job.id"
              [isActive]="jobFilesTabActive$ | async"
            ></app-job-files>
          </ng-template>
        </mat-tab>

        <!--EXTRA JOBS-->
        <mat-tab
          label="Extra Jobs"
          *ngIf="
            job.status !== JobStatusEnum.Draft && (visibleExtraJobs$ | async)
          "
        >
          <ng-template matTabContent>
            <app-extra-jobs
              (extraJobsChange)="onExtraJobsChange($event)"
              (delete)="onDeleteExtraJob($event)"
              (closeJob)="onCloseExtraJob($event)"
              (confirmJob)="onConfirmExtraJob($event)"
              (updateOrCreate)="onUpdateOrCreateExtraJob($event)"
              [isActive]="extraJobsTabActive$ | async"
              [focusedExtraJobId]="focusedExtraJobId$ | async"
              [job]="job"
              [extraJobs]="extraJobs$ | async"
            ></app-extra-jobs>
          </ng-template>
        </mat-tab>

        <!--DOCUMENT TEMPLATES-->
        <mat-tab label="Document Templates" *ngIf="activeUser && activeUser.isCorporateExpert()">
          <ng-template matTabContent>
            <app-document-template-table
              [data]="job.templateData"
              [isActive]="documentTemplatesTabActive$ | async">
            </app-document-template-table>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </section>
  </div>
</ng-container>


<ng-template #confirmBillingDialogTemplate>
  <div class="py-4">
    <p class="text-center">Are you sure the billing is correct?</p>

    <p class="flex items-center justify-center"><mat-icon class="text-warning-50 mr-2">warning</mat-icon> <span class="text-lightGray">After clicking yes, you cannot make fees amendment anymore.</span></p>
  </div>
</ng-template>


<ng-template #confirmProfileDialogTemplate>
  <div class="py-4">
    <p class="text-center">Are you sure the company incorporation information is correct?</p>

    <p class="flex items-center justify-center"><mat-icon class="text-warning-50 mr-2">warning</mat-icon> <span class="text-lightGray">After clicking yes, you cannot make profile amendment anymore.</span></p>
  </div>
</ng-template>

<ng-template #confirmDocumentsPreparedDialogTemplate>
  <div class="py-4">
    <p class="text-center">Are you sure all the documents have been prepared and signed?</p>
  </div>
</ng-template>

<ng-template #confirmMarkAsCompleteDialogTemplate>
  <div class="py-4">
    <p class="text-center">Are you sure you want to mark this job as complete?</p>
  </div>
</ng-template>
